import { useMemo } from 'react';

var PluginType = /* @__PURE__ */ ((PluginType2) => {
  PluginType2["Ads"] = "Ads";
  PluginType2["Analytics"] = "Analytics";
  PluginType2["PageAds"] = "PageAds";
  PluginType2["Gifting"] = "Gifting";
  PluginType2["Paywall"] = "Paywall";
  PluginType2["Privacy"] = "Privacy";
  PluginType2["Player"] = "Player";
  PluginType2["Monitoring"] = "Monitoring";
  return PluginType2;
})(PluginType || {});
var PluginConfigType = /* @__PURE__ */ ((PluginConfigType2) => {
  PluginConfigType2["String"] = "String";
  PluginConfigType2["Boolean"] = "Boolean";
  PluginConfigType2["Number"] = "Number";
  PluginConfigType2["Object"] = "Object";
  PluginConfigType2["Array"] = "Array";
  return PluginConfigType2;
})(PluginConfigType || {});
const createDebugLogger = (pluginName, showDebugLogs) => (...args) => {
  if (showDebugLogs) {
    console.debug(`[${pluginName}]:`, ...args);
  }
};
const useDebugLogger = (pluginName, showDebugLogs) => {
  return useMemo(
    () => createDebugLogger(pluginName, showDebugLogs),
    [pluginName, showDebugLogs]
  );
};
const isTechnicalEvent = (event) => {
  return event.startsWith("tech.");
};
class PluginNotReadyError extends Error {
  constructor(pluginName) {
    super(`${pluginName} is not ready yet`);
    this.name = "PluginNotReadyError";
    this.pluginName = pluginName;
  }
}
var MediaSubtype = /* @__PURE__ */ ((MediaSubtype2) => {
  MediaSubtype2["Generic"] = "GENERIC";
  MediaSubtype2["Video"] = "VIDEO";
  MediaSubtype2["TvShow"] = "TV_SHOW";
  MediaSubtype2["TvShowSeason"] = "TV_SHOW_SEASON";
  MediaSubtype2["TvShowEpisode"] = "TV_SHOW_EPISODE";
  MediaSubtype2["LiveChannel"] = "LIVE_CHANNEL";
  MediaSubtype2["LiveProgram"] = "LIVE_PROGRAM";
  return MediaSubtype2;
})(MediaSubtype || {});

export { MediaSubtype, PluginConfigType, PluginNotReadyError, PluginType, createDebugLogger, isTechnicalEvent, useDebugLogger };
